import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SxProps, TextFieldProps } from '@mui/material';
import { Moment } from 'moment';

export const FormDatePicker = ({
  onChange,
  value,
  sx,
  disabled,
  label,
  textFieldProps,
  popperZIndex,
}: {
  onChange: (e: Moment | null) => void;
  value: Moment | null;
  sx?: SxProps;
  disabled?: boolean;
  label?: string;
  textFieldProps?: TextFieldProps;
  popperZIndex?: number;
}) => {
  const slotProps =
    textFieldProps || popperZIndex != null
      ? {
          ...(textFieldProps ? { textField: textFieldProps } : {}),
          ...(popperZIndex != null ? { popper: { sx: { zIndex: popperZIndex } } } : {}),
        }
      : undefined;

  return (
    <DatePicker
      label={label}
      onChange={e => onChange(e)}
      value={value}
      sx={sx}
      disabled={disabled}
      slotProps={slotProps}
    />
  );
};
